import React, { createContext, useState, useEffect } from 'react';

// Creiamo il contesto per la gestione delle dimensioni e delle proporzioni
const ResponsiveContext = createContext();

const ResponsiveProvider = ({ children }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Aggiungiamo l'event listener per gestire la modifica della larghezza
    window.addEventListener('resize', handleResize);

    // Rimuoviamo l'event listener al momento del dismount del componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Determiniamo la dimensione del dispositivo (mobile, tablet, desktop)
  const getScreenSize = () => {
    if (screenWidth < 640) return 'mobile';
    if (screenWidth < 1024) return 'tablet';
    if (screenWidth <= 1920) return 'desktop';
    return 'large-desktop';
  };

  return (
    <ResponsiveContext.Provider value={{ screenWidth, screenSize: getScreenSize() }}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export { ResponsiveContext, ResponsiveProvider };